const BASE = '/comfy'
const POLL_MS = 2000
const IMG_TIMEOUT_MS = 300_000
const VID_TIMEOUT_MS = 900_000

async function uploadImageBlob(blob, filename = 'selfie.jpg') {
  const form = new FormData()
  form.append('image', blob, filename)
  form.append('overwrite', 'true')
  const r = await fetch(`${BASE}/upload/image`, { method: 'POST', body: form })
  if (!r.ok) throw new Error(`Upload failed: ${r.status}`)
  return (await r.json()).name
}

export async function uploadSelfie(base64DataUrl) {
  const res = await fetch(base64DataUrl)
  const blob = await res.blob()
  return uploadImageBlob(blob, 'selfie.jpg')
}

export async function uploadOutputPng(objectUrl) {
  const res = await fetch(objectUrl)
  const blob = await res.blob()
  return uploadImageBlob(blob, 'output.png')
}

async function queuePrompt(workflow) {
  const clientId = 'kiosk-' + Date.now()
  const r = await fetch(`${BASE}/prompt`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt: workflow, client_id: clientId }),
  })
  if (!r.ok) throw new Error(`Queue failed: ${r.status}`)
  return (await r.json()).prompt_id
}

async function waitForResult(promptId, onProgress, timeoutMs) {
  const start = Date.now()
  while (Date.now() - start < timeoutMs) {
    const r = await fetch(`${BASE}/history/${promptId}`)
    if (r.ok) {
      const hist = await r.json()
      if (hist[promptId]) return hist[promptId]
    }
    onProgress?.((Date.now() - start) / timeoutMs)
    await new Promise((res) => setTimeout(res, POLL_MS))
  }
  throw new Error('Timeout: generation took too long')
}

function findOutputImage(history) {
  for (const node of Object.values(history.outputs || {})) {
    if (node.images?.length) return node.images[0]
  }
  throw new Error('No output image found')
}

function findOutputFile(history) {
  for (const node of Object.values(history.outputs || {})) {
    for (const key of ['images', 'gifs', 'videos']) {
      if (node[key]?.length) return node[key][0]
    }
  }
  throw new Error('No output video found')
}

async function downloadAsObjectUrl(file) {
  const qs = new URLSearchParams({
    filename: file.filename,
    subfolder: file.subfolder || '',
    type: file.type || 'output',
  })
  const r = await fetch(`${BASE}/view?${qs}`)
  if (!r.ok) throw new Error(`Download failed: ${r.status}`)
  return URL.createObjectURL(await r.blob())
}

export async function generateImage(selfieBase64, prompt, onProgress) {
  const workflow = await fetch('/workflows/imagine.json').then((r) => r.json())

  const imageName = await uploadSelfie(selfieBase64)
  workflow['46'].inputs.image = imageName
  workflow['68:6'].inputs.text = prompt
  workflow['68:25'].inputs.noise_seed = Math.floor(Math.random() * 1e15)

  const promptId = await queuePrompt(workflow)
  const history = await waitForResult(promptId, onProgress, IMG_TIMEOUT_MS)
  const img = findOutputImage(history)
  return downloadAsObjectUrl(img)
}

export async function generateVideo(imageObjectUrl, prompt, onProgress) {
  const workflow = await fetch('/workflows/video.json').then((r) => r.json())

  const imageName = await uploadOutputPng(imageObjectUrl)
  workflow['97'].inputs.image = imageName
  workflow['129:93'].inputs.text = prompt
  workflow['129:86'].inputs.noise_seed = Math.floor(Math.random() * 1e15)

  const promptId = await queuePrompt(workflow)
  const history = await waitForResult(promptId, onProgress, VID_TIMEOUT_MS)
  const file = findOutputFile(history)
  return downloadAsObjectUrl(file)
}
